// Settings › Prices: consumer financing (BL-005), the lender, the link a customer applies on, and the
// plans offered. Options then show "as low as $X a month" from these (asLowAs, @flowology/domain).
import type { FinancingPlan, FinancingSetting } from '@flowology/domain';

export { asLowAsWords, safeApplyUrl, type FinancingSetting } from '@flowology/domain';

/** "$12.34": cents as dollars, to two places. */
const dollars = (cents: number) =>
  `$${(cents / 100).toLocaleString('en-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

/** One plan in words: "120 months at 9.99 %, from $5,000.00". */
export const planWords = (p: FinancingPlan) =>
  `${p.months} months at ${p.aprPercent} %${p.minCents ? `, from ${dollars(p.minCents)}` : ''}`;

/** The setting read-only: "Financeit · 2 plans: 12 months at 0 %; 120 months at 9.99 %", or off. */
export function financingWords(v: FinancingSetting): string {
  if (!v.plans.length) return `${v.lender} · no plans: options show no monthly payment`;
  return `${v.lender} · ${v.plans.length} plan${v.plans.length === 1 ? '' : 's'}: ${v.plans.map(planWords).join('; ')}`;
}

/** Why the plans can't be saved yet, or null. */
export function financingProblem(v: FinancingSetting): string | null {
  if (!v.lender.trim()) return 'Name the lender.';
  if (v.applyUrl && !/^https:\/\/\S+$/.test(v.applyUrl)) return 'The apply link starts with https://.';
  for (const p of v.plans) {
    if (!Number.isInteger(p.months) || p.months < 1 || p.months > 240) return 'A plan is 1 to 240 months.';
    if (!(p.aprPercent >= 0 && p.aprPercent <= 40)) return 'A plan’s rate is 0 to 40 %.';
  }
  return null;
}
